import { render, staticRenderFns } from "./PetitionFilters.vue?vue&type=template&id=68bdfec1"
import script from "./PetitionFilters.vue?vue&type=script&lang=js"
export * from "./PetitionFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports